import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ValidationOptions } from 'react-hook-form/dist/types';
import { useTranslation } from 'react-i18next';
import { OutlinedTextFieldProps } from '@mui/material/TextField/TextField';
import { validateRequired } from 'utils/form';
import { MuiInput } from './MuiInput';

interface IRegisteredMuiInput extends Partial<OutlinedTextFieldProps> {
	name: string;
	validation?: ValidationOptions;
}

export const RegisteredMuiInput = ({
	name,
	label,
	validation,
	required,
	...props
}: IRegisteredMuiInput) => {
	const { t } = useTranslation('errors');
	const { control, errors } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			rules={{
				...validateRequired(required, t('required')),
				...validation,
			}}
			value={props.value}
			as={<MuiInput label={label} error={!!errors[name]} {...props} />}
		/>
	);
};
